<template>
	<div class="screen-wrapper">
		<div
			v-if="($route.params.current != 'startseite')"
			@click="(! iscampaingsite() ? $router.push('/') : false)"
			class="site-logo animated zoomIn delay-05s"
		>
			<a href="https://www.amecke.de/">
				<img id="headerlogo" src="https://www.amecke.de/files/images/Aktionen/mehr-leben/logo2022.svg" alt="Amecke" />
			</a>
		</div>

		<button @click="openMobileNavigation" type="button" class="menu-toggler" title="Hauptmenü">
			<span class="sr-only">Toggle navigation</span>
			<span class="burgericon"></span>
			<span class="burgericon"></span>
			<span class="burgericon"></span>
		</button>

		<app-navigation></app-navigation>
	</div>
</template>

<script>
	import navigation from "./NavigationComponent.vue";

	export default {
		components: {
			"app-navigation": navigation
		},
		methods: {
			openMobileNavigation() {
				let elementBody = document.querySelector("body");
				elementBody.classList.toggle("js-mobilenav-is-active");
			},

			iscampaingsite() {
				return document.body.classList.contains("site-campaign");
			}
		},
		mounted() {},
		computed: {}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";

	.site-header {
		min-height: auto;
		padding: 23px 0 23px 0;
		position: fixed;
		top: 0;
		transition: min-height 0.25s ease-in-out, background-image 0.5s ease-in-out;
		width: 100%;
		z-index: 5;
		@include min-screen($screen-min-m) {
			background: linear-gradient(
				to bottom,
				#ffffff,
				rgba(#ffffff, 0.8),
				rgba(#ffffff, 0.6),
				rgba(#ffffff, 0)
			);
		}
		.js-mobilenav-is-active & {
			background-image: linear-gradient(
				to bottom,
				#ffffff,
				rgba(#ffffff, 0.8),
				rgba(#ffffff, 0.6),
				rgba(#ffffff, 0)
			);
		}

		.js-nav-is-active & {
			min-height: 90vh;
		}

		@include min-screen($screen-min-m) {
			.js-nav-is-active & {
				min-height: auto;
				padding: 30px 0 30px;
			}

			.js-nav-background & {
				min-height: 235px;
			}
		}

		.screen-wrapper {
			@include min-screen($screen-min-m) {
				display: flex;
				align-items: center;
			}
		}
	}

	.menu-toggler {
		background-color: transparent;
		background-image: none;
		border-color: transparent;
		border: 1px solid transparent;
		border-radius: 0;
		height: 35px;
		margin: 0;
		margin-left: $wrapper-padding;
		padding: 0;
		position: relative;
		width: 35px;

		&:focus {
			outline: none;
		}

		@include min-screen($screen-min-m) {
			display: none;
		}

		.burgericon {
			background-color: $color-green;
			border-radius: 3px;
			display: block;
			height: 3px;
			left: 0;
			position: absolute;
			transition: all 0.3s ease-in-out;
			width: 32px;

			&:nth-child(2) {
				top: 0px;
			}

			&:nth-child(3) {
				top: 10px;
			}

			&:nth-child(4) {
				top: 20px;
			}

			.js-mobilenav-is-active & {
				&:nth-child(2) {
					top: 10px;
					transform: rotate(45deg);
				}

				&:nth-child(3) {
					opacity: 0;
				}

				&:nth-child(4) {
					top: 10px;
					transform: rotate(-45deg);
				}
			}
		}
	}

	.site-logo {
		display: none;

		@include min-screen($screen-min-m) {
			display: inline-block;
			height: 130px;
			left: 0;
			position: absolute;
			top: 0;
			width: 130px;
		}
	}
</style>